import { connect } from 'react-redux';
import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { openAssignDomainsToGroupModal } from '../../../common/actions/modal-action-creators';
import ActionButton from './action-button';

export class GroupDomainsButtonContainer extends Component{
    handleGroupDomains = () => {
        const { selectedDomains, openAssignDomainsToGroupModal } = this.props;
        const domains = selectedDomains.map( domain => domain.domainName );

        openAssignDomainsToGroupModal( domains );
    }

    render(){
        return (
            <ActionButton
                onClick={this.handleGroupDomains}
                dataId="domain-management-group-domains-button"
            >
                Group Domains
            </ActionButton>
        );
    }
};

GroupDomainsButtonContainer.propTypes = {
    openAssignDomainsToGroupModal: PropTypes.func.isRequired,
    selectedDomains: PropTypes.array.isRequired,
};

export default connect( null, { openAssignDomainsToGroupModal } )( GroupDomainsButtonContainer );
